module.exports = __webpack_public_path__ + "img/carrito.1e7c570c.svg";